import React from 'react';
import styles from './toggle.module.css';

const Toggle = ({ isOn, setIsOn }) => {
  return (
    <div
      onClick={() => setIsOn(!isOn)}
      className={styles.switch}
    >
      <div
        className={`${styles.knob} ${isOn ? styles.active : ''}`}
      />
    </div>
  );
};

export default Toggle;
